
/* Environments setup */

let env = 'PROD';
// let env = 'STAGE';
//let env = 'QA';
//const env = 'DEV';
let url;

if (env === 'DEV') {
  url = {
    api_url: 'https://api.qa.wellbrain.co',
    provider_url: 'https://provider.qa.wellbrain.co'
  };
} else if (env === 'STAGE') {
  url = {
    api_url: 'https://api.stage.wellbrain.co',
    provider_url: 'https://provider.stage.wellbrain.co'
  };
} else if (env === 'QA') {
  url = {
    api_url: 'https://api.qa.wellbrain.co',
    provider_url: 'https://provider.qa.wellbrain.co'
  };
} else if (env === 'PROD') {
  url = {
    api_url: 'https://api.wellbrain.co',
    provider_url: 'https://provider.wellbrain.co'
  };
}
/*else if (env === 'STAGE') {
    url = {
        api_url: 'https://stage.wellbrain.co',
        provider_url: 'https://provider.stage.wellbrain.co'
    };
}else if (env === 'QA'){
    url = {
        api_url: 'https://api.qa.wellbrain.co',
        provider_url: 'https://provider.qa.wellbrain.co'
  };
}else if (env === 'PROD') {
    url = {
        api_url: 'https://wellbrain.co',
        provider_url: 'https://provider.wellbrain.co'
    };
}
*/


export const config = url;




// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/providers/config.ts